export interface ProductIdentityInput {
  product_title?: unknown;
  product?: unknown;
  ship_from?: unknown;
  country_sets?: unknown;
}

export function productTitle(product: ProductIdentityInput): string {
  return String(product.product_title ?? product.product ?? '').trim()
    .replace(/\s*(?:\((?:US-US|UK-UK|EU-EU)\)|(?:US-US|UK-UK|EU-EU))\s*$/i, '').trim();
}

export function productDelivery(product: ProductIdentityInput): string {
  const rawOrigin = String(product.ship_from ?? '').trim().toUpperCase();
  const origin = rawOrigin === 'UK' ? 'GB' : rawOrigin;
  const routes: Record<string, [string, string]> = {
    US: ['United States', 'US2US (fast delivery)'],
    GB: ['United Kingdom', 'UK2UK (fast delivery)'],
    EU: ['European countries', 'EU2EU (fast delivery)'],
  };
  const route = routes[origin];
  const raw = product.country_sets;
  const sets = Array.isArray(raw) ? raw : typeof raw === 'string' && raw.trim() && !['s:0:"";', 'a:0:{}', 'N;'].includes(raw) ? [raw] : [];
  const regions: Record<string, string> = { US: 'United States', USA: 'United States', GB: 'United Kingdom', UK: 'United Kingdom', EU: 'European Union' };
  const labels = sets.filter(v => typeof v === 'string').map(v => {
    const set = v.trim();
    return route && set === route[0] ? route[1] : regions[set.toUpperCase()] ?? set;
  }).filter(Boolean);
  return labels.length ? [...new Set(labels)].join(', ') : 'Worldwide';
}
